import script from "./TopTenTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTenTable.vue?vue&type=script&setup=true&lang=js"

import "./TopTenTable.vue?vue&type=style&index=0&id=5e1d716c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1d716c"]])

export default __exports__